import { includes } from 'lodash';
import useTagList from '../../../../../../hooks/queries/tag/useTagList';
import { GetTagListRequest } from '../../../../../../lib/api/tag/type';
import { TableOption } from '../types';
import { TagItem } from '../../../types';
import { TagsFindResponseBodyDto } from '../../../../../../types/api/tags';
import { setDateFormat } from '../../../../../../lib/moment';
import { DATE_FORMAT } from '../../../../../../constants/service/common/utilConstants';
import { checkValidId } from '../../../../../../lib/utils/common/checkValideId';

const convertRequest = (option: TableOption): GetTagListRequest => {
  const { filterOption, pagination } = option;
  return {
    id: filterOption.id || null,
    name: filterOption.name,
    page: pagination.pageNum + 1,
    pageSize: pagination.pageSize,
    status: 'active',
  };
};

const convertResponse = (data: TagsFindResponseBodyDto, selectedProductIdList: number[]) => {
  const { totalCount, tags } = data;
  return {
    totalCount,
    tagList: tags.map((item) => ({
      id: item.id,
      name: item.name,
      status: item.status,
      tagGroupList: item.tagGroups.map((item) => item.name),
      imageUrl: item.tagAttachments[0]?.url,
      uncheckable: includes(selectedProductIdList, item.id),
      createDate: setDateFormat(item.createDate, DATE_FORMAT.FULL_DASH_FORMAT),
    })),
  };
};

type UseTagListData = {
  totalCount: number;
  tagList: TagItem[];
};
interface UseTagListModal {
  data?: UseTagListData;
}
const useTagListModal = (option: TableOption, selectedProductIdList: number[]): UseTagListModal => {
  const isValidId = checkValidId([option.filterOption.id]);

  const { data } = useTagList<UseTagListData>({
    payload: convertRequest(option),
    options: {
      select: (data) => convertResponse(data, selectedProductIdList),
      placeholderData: {
        totalCount: 0,
        tags: [],
      },
      // 유효한 ID가 있을 때만 API 요청을 수행하도록 설정
      enabled: isValidId,
      keepPreviousData: true,
    },
  });

  return {
    // 유효하지 않은 ID일 경우, API 호출 결과 대신 빈 데이터 객체를 반환
    data: isValidId ? data : { totalCount: 0, tagList: [] },
  };
};

export default useTagListModal;
